/**
 * Custom day layout: same as no-overlap but treats vertically adjacent (touching)
 * events as overlapping so back-to-back jobs get side-by-side columns instead of stacking.
 */
import overlap from "react-big-calendar/lib/utils/layout-algorithms/overlap";

const TOUCH_THRESHOLD = 0.5; // % of day height – treat as "touching" if gap is smaller

function getMaxIdxDFS(node, maxIdx, visited) {
  for (let i = 0; i < node.friends.length; i++) {
    if (visited.indexOf(node.friends[i]) > -1) continue;
    maxIdx = Math.max(maxIdx, node.friends[i].idx);
    visited.push(node.friends[i]);
    const newIdx = getMaxIdxDFS(node.friends[i], maxIdx, visited);
    maxIdx = Math.max(maxIdx, newIdx);
  }
  return maxIdx;
}

function areFriends(se1, se2) {
  const y1 = se1.style.top;
  const y2 = se1.style.top + se1.style.height;
  const y3 = se2.style.top;
  const y4 = se2.style.top + se2.style.height;
  const overlap =
    (y3 >= y1 && y4 <= y2) || (y4 > y1 && y4 <= y2) || (y3 >= y1 && y3 < y2);
  const touching =
    Math.abs(y3 - y2) < TOUCH_THRESHOLD || Math.abs(y4 - y1) < TOUCH_THRESHOLD;
  return overlap || touching;
}

export default function noOverlapTouching(args) {
  const styledEvents = overlap(args);
  styledEvents.sort((a, b) => {
    const sa = a.style;
    const sb = b.style;
    if (sa.top !== sb.top) return sa.top > sb.top ? 1 : -1;
    return sa.top + sa.height < sb.top + sb.height ? 1 : -1;
  });

  styledEvents.forEach((se) => {
    se.friends = [];
    delete se.style.left;
    delete se.idx;
    delete se.size;
  });

  for (let i = 0; i < styledEvents.length - 1; i++) {
    const se1 = styledEvents[i];
    for (let j = i + 1; j < styledEvents.length; j++) {
      const se2 = styledEvents[j];
      if (areFriends(se1, se2)) {
        se1.friends.push(se2);
        se2.friends.push(se1);
      }
    }
  }

  styledEvents.forEach((se) => {
    const bitmap = Array(100).fill(1);
    se.friends.forEach((f) => {
      if (f.idx !== undefined) bitmap[f.idx] = 0;
    });
    se.idx = bitmap.indexOf(1);
  });

  styledEvents.forEach((se) => {
    if (se.size) return;
    const allFriends = [];
    const maxIdx = getMaxIdxDFS(se, 0, allFriends);
    const size = 100 / (maxIdx + 1);
    se.size = size;
  });

  styledEvents.forEach((e) => {
    e.style.left = e.idx * e.size;
    let maxIdx = 0;
    e.friends.forEach((f) => (maxIdx = Math.max(maxIdx, f.idx)));
    if (maxIdx <= e.idx) e.size = 100 - e.idx * e.size;
    const padding = e.idx === 0 ? 0 : 3;
    e.style.width = `calc(${e.size}% - ${padding}px)`;
    e.style.height = `calc(${e.style.height}% - 2px)`;
    e.style.xOffset = `calc(${e.style.left}% + ${padding}px)`;
  });

  return styledEvents;
}
